import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import sourceData from './modules/source_data'
import parm from './modules/parm'
import dbMap from './modules/db_map'
import dbPreMap from './modules/db_pre_map'
import solutionProcess from './modules/process'
import assign from './modules/assign'
import loading from './modules/loading'
import dataCase from './modules/case'
import notice from './modules/notice'
import prediction from './modules/prediction'
import userInfo from './modules/user_info'
import ele from './modules/ele'

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    assign,
    ele,
    sourceData,
    parm,
    dbMap,
    dbPreMap,
    solutionProcess,
    loading,
    dataCase,
    notice,
    prediction,
    userInfo
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js